import React from "react";
import Scrollchor from "react-scrollchor";

export default () => (
  <section id="three" className="spotlight style3 left">
    <span className="image fit main bottom">
      <img src="images/pic04.jpg" alt="" />
    </span>
    <div className="content">
      <header>
        <h2>Experience</h2>
        {/*<p>Accomplishments</p>*/}
      </header>
      <ul>
        <li>
          Engineered dynamic components that allow users to fluently navigate through apps.
        </li>
        <li>
          Conceptualized and implemented software logic and developed and designed database structures.
        </li>
        <li>Created reusable code and libraries that power the inner workings of various apps</li>
        <li>
          "Mentored over 100 sessions, teaching JavaScript, HTML, CSS, Rails, and React to junior developers."
        </li>
        <li>
          Mentored over 100 sessions teaching javascript, html, css, rails,
          react
        </li>
        <li>Co-Lead Developer at Unfounded Labs (start up)</li>
        <li>Technical Support Engineer at Microverse.</li>
      </ul>
      {/*<ul className="actions">*/}
      {/*    <li><a href="#projects" className="button">Learn More</a></li>*/}
      {/*</ul>*/}
    </div>
      <Scrollchor
          to={"#footer"}
          className={"goto-next"}
          animate={{offset: 20, duration: 600}}
      >
          Next
      </Scrollchor>
  </section>
);
